export default __webpack_public_path__ + "static/water_red-3466fb437a129bbeed02c7a05ed6217a.png";